import { CombosTable } from 'components/Combos';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Combos = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );

  const canView = checkPermission(permissions, {
    permissionName: 'ComboItems',
    permission: ['view', 'viewAll'],
  });

  return <div>{canView && <CombosTable />}</div>;
};
